module.exports = __webpack_public_path__ + "773e9dccccb778c1f80dadc987640940.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-11.png
// module id = 1488
// module chunks = 0